import { DesignPartnerApplyForm } from "../DesignPartnerApplyForm";

export function ApplyPage() {
  return (
    <section className="page cta" id="apply" data-testid="dp-page-apply">
      <div className="wrap">
        <div className="eyebrow" style={{ color: "#91b5ff" }}>
          Design-partner program
        </div>
        <h2>Help us validate a better way to run critical projects.</h2>
        <p>
          We are speaking with a small group of project and operations leaders. This is a discovery
          conversation—not a product trial.
        </p>
        <DesignPartnerApplyForm />
      </div>
    </section>
  );
}
